import React, { useEffect, useState } from "react";
import { fetchCourseByCourseId } from "../../api/courseApi";
import { fetchCourseVideoById } from "../../api/courseVideoApi";
import Loading from "../common/Loading";
import { Link } from "react-router-dom";
import HtmlReader from "../common/HtmlReader";
import ToastService from "../../services/ToastService";
import { useSelector } from "react-redux";
import Modal3Js from "../Modal3Js";

const Lesson = ({ courseId, lessonId }) => {
  const user = useSelector((state) => state.user.user);
  const [dataCourseVideo, setDataCourseVideo] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchDataCourseVideo = async () => {
    try {
      const data = await fetchCourseVideoById({
        courseVideoId: lessonId,
        userId: user && user.guid,
      });

      if (data) {
        setDataCourseVideo(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      setIsModalOpen(true);
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchDataCourseVideo();
  }, [lessonId]);

  return (
    <>
      {isModalOpen && (
        <Modal3Js
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Notification"
          submitText="Confirm"
          cancelText="Cancel"
        >
          <p>
            Please{" "}
            <Link to={"/course/" + courseId} data-router-disabled="">
              buy this course
            </Link>{" "}
            or{" "}
            <Link to={"/pricing"} data-router-disabled="">
              upgrade
            </Link>{" "}
            to package Gold or Diamond to watch this lesson!
          </p>
          <p>
            If you don't have money on your account,{" "}
            <Link to={"/account/mywallet"} data-router-disabled="">
              click here
            </Link>{" "}
            to add money to your account.
          </p>

          <div className="buttons">
            {/* <Link to="/account/addmoney" data-router-disabled="" className="button is-purple">
                <span className="hover"></span>
                <span className="label">


                  Nạp tiền


                </span>
              </Link> */}

            <button
              className="js-close button"
              onClick={() => {
                setIsModalOpen(false);
              }}
            >
              <span className="hover"></span>
              <span className="label">Close</span>
            </button>
          </div>
        </Modal3Js>
      )}
      {dataCourseVideo && (
        <>
          <div className="js-player-top player-top">
            <section className="all-challenges js-all-challenges">
              <div
                className="video"
                style={{
                  textAlign: "center",
                  position: "relative",
                  width: "80%",
                  margin: "auto",
                }}
              >
                <iframe
                  title="1xx"
                  width="100%"
                  height={600}
                  src={
                    "https://drive.google.com/file/d/" +
                    dataCourseVideo.driverId +
                    "/preview"
                  }
                  frameborder="0"
                  allowFullScreen
                  style={{ borderRadius: "10px", position: "relative" }}
                ></iframe>
                {dataCourseVideo.videoType.includes("mp4") ? (
                  <div
                    style={{
                      width: "100%",
                      height: "60px",
                      position: "absolute",
                      opacity: 1,
                      right: "0px",
                      top: "0px",
                      backgroundColor: "black",
                    }}
                  >
                    &nbsp;
                  </div>
                ) : (
                  <div
                    style={{
                      width: "5%",
                      height: "60px",
                      position: "absolute",
                      opacity: 1,
                      right: "0px",
                      top: "0px",
                      borderRadius: "10px",
                      backgroundColor: "black",
                    }}
                  >
                    &nbsp;
                  </div>
                )}
              </div>
            </section>
          </div>
          <div className="js-lesson-content content width-1792">
            <header className="details">
              <div className="side informations">
                {/* <div className="sibling is-previous">
                  <a
                    className="sibling-link"
                    href="https://threejs-journey.com/lessons/first-threejs-project"
                    data-router-set=""
                  >
                    <div className="sibling-info">
                      <div className="sibling-label">03.</div>
                      <div className="sibling-title">
                        First Three.js Project
                      </div>
                    </div>
                    <span className="arrow">
                      <svg
                        width="11"
                        height="7"
                        viewBox="0 0 11 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.5 7C5.10218 7 4.72064 6.84197 4.43934 6.56066L0.439339 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.439339 0.43934C1.02513 -0.146446 1.97487 -0.146446 2.56066 0.43934L5.5 3.37868L8.43934 0.43934C9.02513 -0.146447 9.97487 -0.146447 10.5607 0.439339C11.1464 1.02513 11.1464 1.97487 10.5607 2.56066L6.56066 6.56066C6.27936 6.84197 5.89782 7 5.5 7Z"
                          fill="white"
                        ></path>
                      </svg>
                    </span>
                  </a>
                </div> */}
                <div className="current-lesson">
                  {/* <div className="label">{dataCourseVideo.order}.</div> */}
                  <h2 className="title">{dataCourseVideo.title}</h2>
                  {/* <p className="difficulty">
                    Difficulty <span className="value">Medium</span>
                  </p> */}
                </div>
                {/* <div className="sibling is-next">
                  <a
                    className="sibling-link"
                    href="https://threejs-journey.com/lessons/animations"
                    data-router-set=""
                  >
                    <div className="sibling-info">
                      <div className="sibling-label">05.</div>
                      <div className="sibling-title">Animations</div>
                    </div>
                    <span className="arrow">
                      <svg
                        width="11"
                        height="7"
                        viewBox="0 0 11 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.5 7C5.10218 7 4.72064 6.84197 4.43934 6.56066L0.439339 2.56066C-0.146447 1.97487 -0.146447 1.02513 0.439339 0.43934C1.02513 -0.146446 1.97487 -0.146446 2.56066 0.43934L5.5 3.37868L8.43934 0.43934C9.02513 -0.146447 9.97487 -0.146447 10.5607 0.439339C11.1464 1.02513 11.1464 1.97487 10.5607 2.56066L6.56066 6.56066C6.27936 6.84197 5.89782 7 5.5 7Z"
                          fill="white"
                        ></path>
                      </svg>
                    </span>
                  </a>
                </div> */}
              </div>
              {dataCourseVideo.files && (
                <>
                  <div className="side aside">
                    <div className="aside-section files">
                      <div className="title">
                        <span className="icon">
                          <svg
                            version="1.1"
                            id="Calque_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 15 18"
                          >
                            <path
                              className="st0"
                              d="M13.5,18h-12C0.7,18,0,17.3,0,16.5S0.7,15,1.5,15h12c0.8,0,1.5,0.7,1.5,1.5S14.3,18,13.5,18z"
                            ></path>
                            <path
                              className="st0"
                              d="M13.7,8.6c-0.5-0.7-1.4-0.8-2.1-0.4L9,10.1V1.5C9,0.7,8.3,0,7.5,0S6,0.7,6,1.5v8.6L3.4,8.3C2.7,7.8,1.7,8,1.3,8.6C0.8,9.3,1,10.3,1.6,10.7l5.9,4.1l5.9-4.1C14,10.3,14.2,9.3,13.7,8.6z"
                            ></path>
                          </svg>
                        </span>
                        <span className="label">Downloads</span>
                      </div>
                      {dataCourseVideo.files.map((itemFile, index) => {
                        return (
                          <>
                            <a
                              href={itemFile.path}
                              data-router-disabled=""
                              download=""
                              target="_blank"
                              className={index % 2 === 0 ? '"button starter"':'button final'}
                              rel="noopener noreferrer"
                            >
                              <span className="hover"></span>
                              <span className="label">
                                {itemFile.sourceType}
                              </span>
                            </a>
                          </>
                        );
                      })}
                    </div>
                  </div>
                </>
              )}
            </header>

            <section className="text js-text">
              {dataCourseVideo && (
                <HtmlReader html={dataCourseVideo.description} />
              )}
            </section>
          </div>
        </>
      )}
    </>
  );
};

export default Lesson;
